'use client';

export { BookAppointmentWidget as BookAppointmentWidgetB } from './BookAppointmentWidget';
